module.exports = __webpack_public_path__ + "img/shopIcon1.49f70803.png";